module.exports = __webpack_public_path__ + "img/strahov.89bfccba.png";